// HomeView.js
// Component for the main view

// Imports
import React from 'react';
import MainView from './MainView/';

// Component Class
// Draws the main view area of the default path
class HomeView extends React.Component {
  // Renders Component
  render() {
    return <MainView />;
  }
}

// Exports
export default HomeView;



// WEBPACK FOOTER //
// ./src/components/HomeView.js